export enum experimentKeyEnum {
  WIX_WEBSITES_PDP = 'vxw_pdp_hero_layout',
  WIX_WEBSITES_PDP_PERFORMANCE_ANALYSIS = 'vxw_websitespdp_performance_analysis',
  WIX_WEBSITES_PDP_HERO_PERSONALIZATION = 'vxw_websites_pdp_hero_personalization',
  WIX_WEBSITES_SHORTER_FREEMIUM_PREMIUM_JOURNEY = 'vxw_shorter_freemium_to_premium_journey',
}

export enum variationKeyEnum {
  WIX_WEBSITES_PDP_CONTROL_VARIATION = 'control',
  WIX_WEBSITES_PDP_TEST_VARIATION = 'test',
}

export const experimentLocales = ['en-gb', 'en-ca', 'fr-ca', 'en-nz', 'en-au']
export const dynamicHeroExperimentLocales = ['en-us', 'en-ie', 'en-ca', 'en-au', 'en-nz', 'en-sg', 'en-gb']
